export default "__VITE_ASSET__fd4bb2fb__"